/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoStatusDTO
 */
export interface AssistitoStatusDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoStatusDTO
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoStatusDTO
     */
    hasAllergie?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoStatusDTO
     */
    hasICE?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoStatusDTO
     */
    hasIntolleranze?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoStatusDTO
     */
    hasMalattie?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoStatusDTO
     */
    hasPatologieInfettive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoStatusDTO
     */
    hasTerapie?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoStatusDTO
     */
    hasTraumi?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoStatusDTO
     */
    hasAnamnesi?: boolean;
}

/**
 * Check if a given object implements the AssistitoStatusDTO interface.
 */
export function instanceOfAssistitoStatusDTO(value: object): value is AssistitoStatusDTO {
    return true;
}

export function AssistitoStatusDTOFromJSON(json: any): AssistitoStatusDTO {
    return AssistitoStatusDTOFromJSONTyped(json, false);
}

export function AssistitoStatusDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoStatusDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'hasAllergie': json['hasAllergie'] == null ? undefined : json['hasAllergie'],
        'hasICE': json['hasICE'] == null ? undefined : json['hasICE'],
        'hasIntolleranze': json['hasIntolleranze'] == null ? undefined : json['hasIntolleranze'],
        'hasMalattie': json['hasMalattie'] == null ? undefined : json['hasMalattie'],
        'hasPatologieInfettive': json['hasPatologieInfettive'] == null ? undefined : json['hasPatologieInfettive'],
        'hasTerapie': json['hasTerapie'] == null ? undefined : json['hasTerapie'],
        'hasTraumi': json['hasTraumi'] == null ? undefined : json['hasTraumi'],
        'hasAnamnesi': json['hasAnamnesi'] == null ? undefined : json['hasAnamnesi'],
    };
}

export function AssistitoStatusDTOToJSON(value?: AssistitoStatusDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'hasAllergie': value['hasAllergie'],
        'hasICE': value['hasICE'],
        'hasIntolleranze': value['hasIntolleranze'],
        'hasMalattie': value['hasMalattie'],
        'hasPatologieInfettive': value['hasPatologieInfettive'],
        'hasTerapie': value['hasTerapie'],
        'hasTraumi': value['hasTraumi'],
        'hasAnamnesi': value['hasAnamnesi'],
    };
}

